/* LUVIA dynamic price + shipping breakdown (Balance w/ inline total) */
(function() {
  var DEBUG = false; // set true to see console logs
  function log(){ if(DEBUG) console.log.apply(console, ['[LUVIA-PB]'].concat([].slice.call(arguments))); }

  /* ---- helpers ---- */
  function fmt(cents){
    if (window.Shopify && typeof Shopify.formatMoney === 'function'){
      return Shopify.formatMoney(cents, window.Shopify.money_format || '£{{amount}}');
    }
    return '£' + (cents/100).toFixed(2);
  }

  function getPB(){ return document.getElementById('luv-price-breakdown'); }
  function getData(pb){
    return {
      unitPriceCents: parseInt(pb.dataset.unitPrice || '0', 10) || 0,
      freeQty:        parseInt(pb.dataset.freeQty || '2', 10)   || 2,
      shipFeeText:    pb.dataset.shipFee || '£3.65'
    };
  }
  function shipFeeNum(txt){
    return Math.round((parseFloat(txt.replace(/[^0-9.]/g,'')) || 0) * 100);
  }

  /* find current quantity */
  function currentQty(){
    var els = document.querySelectorAll('input[name="quantity"]');
    for (var i=0;i<els.length;i++){
      var el = els[i];
      if (el.disabled) continue;
      var v = parseInt(el.value, 10);
      if (!isNaN(v) && v > 0) return v;
    }
    return 1;
  }

  /* inline total element (next to main price) */
  function getInlineEl(){
    var el = document.getElementById('luv-price-total-inline');
    if (el) return el;
    // insert after first .price-item--regular on page
    var priceEl = document.querySelector('.price-item--regular');
    if (!priceEl) return null;
    el = document.createElement('span');
    el.id = 'luv-price-total-inline';
    el.className = 'luv-price-total-inline';
    priceEl.insertAdjacentElement('afterend', el);
    return el;
  }

  /* main update */
  function update(){
    var pb = getPB();
    if(!pb){ log('no pb'); return; }
    var lineEl    = pb.querySelector('[data-luv-pb-line]');
    var subTextEl = pb.querySelector('[data-luv-pb-subtext]');
    if(!lineEl || !subTextEl){ log('no child spans'); return; }

    var data = getData(pb);
    var unit = data.unitPriceCents;
    var fq   = data.freeQty;
    var sfTxt= data.shipFeeText;
    var sf   = shipFeeNum(sfTxt);
    var qty  = currentQty();

    // update inline price add‑on
    var inlineEl = getInlineEl();

    if (qty >= fq){
      var total = unit * qty;
      // PDP breakdown block
      lineEl.textContent = fmt(total) + ' total – Free UK shipping!';
      subTextEl.textContent = '🎉 Free UK shipping included!';
      pb.classList.add('luv-free'); pb.classList.remove('luv-paid');
      // inline block
      if (inlineEl){
        inlineEl.textContent = '· Total: ' + fmt(total) + ' Free UK shipping';
        inlineEl.classList.add('luv-price-total-inline--free');
      }
   } else {
  var total = (unit * qty) + sf;
  lineEl.textContent = '+ ' + sfTxt + ' shipping · Total: ' + fmt(total);
  subTextEl.textContent = 'Free UK shipping when you add ' + fq + '+ bottles.';
  pb.classList.add('luv-paid'); pb.classList.remove('luv-free');
  if (inlineEl){
    inlineEl.textContent = '+ ' + sfTxt + ' shipping · Total: ' + fmt(total);
    inlineEl.classList.remove('luv-price-total-inline--free');
  }

      
    }
    log('update', {qty:qty,total:total});
  }

  /* bind events once per page load */
  function bind(){
    update(); // initial draw

    // quantity changes
    document.addEventListener('input', function(e){
      if (e.target.name === 'quantity') update();
    }, true);
    document.addEventListener('change', function(e){
      if (e.target.name === 'quantity') update();
    }, true);
    document.addEventListener('click', function(e){
      if (e.target.closest('quantity-input') || e.target.matches('[data-action*="quantity"]')){
        setTimeout(update, 0);
      }
    }, true);
  }

  /* safe init (works even if DOM already loaded) */
  function safeInit(){
    bind();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
  document.addEventListener('shopify:section:load', safeInit); // OS 2.0 re‑render
})();
